import { MapPin } from "lucide-react";

export const MARYLAND_REGIONS = [
 "Central Maryland",
 "Southern Maryland",
 "Western Maryland",
 "Eastern Shore",
 "Capital Region",
 "Northern Maryland",
];

export const MARYLAND_TAGLINE = "Telehealth across Maryland region";

export default function MarylandCoverage({ tone = "light" }) {
 const isDark = tone === "dark";
 return (
 <div data-testid="md-coverage" className={`${isDark ? "text-cream/85" : "text-ink"}`}>
 <div className="flex items-center gap-2 text-sm font-medium">
 <MapPin className={`w-4 h-4 ${isDark ? "text-gold-400" : "text-sage-700"}`} strokeWidth={1.75} />
 {MARYLAND_TAGLINE}
 </div>
 <ul className={`mt-3 grid grid-cols-2 gap-y-1.5 gap-x-4 text-xs ${isDark ? "text-cream/70" : "text-muted_text"}`}>
 {MARYLAND_REGIONS.map((r) => (
 <li key={r} data-testid={`md-region-${r.toLowerCase().replace(/\s+/g, "-")}`} className="inline-flex items-center gap-1.5">
 <span className={`w-1 h-1 rounded-full ${isDark ? "bg-gold-400" : "bg-gold-500"}`} /> {r}
 </li>
 ))}
 </ul>
 </div>
 );
}
